import {React, observer, computed, useLocalStore, useAsObservableSource, Fragment} from '@api'
import {OptionalShapeTitle, ShapeComponentStoreContext, ShapeStyles, TDBaseShape, TldrawApp, useShapeComponentStore, useTldrawApp} from '@modules/whiteboard'
import {HTMLContainer, TLComponentProps} from '@tldraw/core'
import {MyImage} from 'centric-ui-components'
import {ImageUtil} from '.'
import {ShapeComponentStore} from '@modules/whiteboard/shapes/ShapeComponentStore'
import * as css from './ImageShapeComponent.css'

/// region Components

export interface ImageShape extends TDBaseShape {
  type: 'image'
  size: number[]
  dataUrl?: string
  exId?: string
  objectFit?: 'contain' | 'cover'
}

export class ImageShapeStore extends ShapeComponentStore<ImageShape, ImageUtil> {
  constructor(public props: TLComponentProps<ImageShape> & { app: TldrawApp }) {
    super(props)
  }
  get shape() { return this.props.shape}

  @computed get cssStyles() {
    const {shape: {objectFit, size: [width, height]}} = this
    return {
      width: `${width}px`,
      height: `${height}px`,
      '--object-fit': objectFit ?? 'contain'
    } as any
  }

  @computed get imageSrc() {
    const {app, shape} = this
    return app.imageUrlFor(shape)
  }
}

export const ImageShapeComponent = observer<TLComponentProps<ImageShape>, any>(function ImageShapeComponent(props, ref) {
  const app = useTldrawApp(),
    obsProps = useAsObservableSource({...props, app}),
    store = useLocalStore(() => new ImageShapeStore(obsProps)),
    {id, imageSrc, cssStyles, props: {shape, events, isSelected}, app: {stores: {authStore: {securityTokenURL}}}} = store,
    {exId} = shape

  return (
    <ShapeComponentStoreContext.Provider value={store}>
      <HTMLContainer id={id}
                     ref={ref}
                     className={css.root}
                     {...events}
      >
        <OptionalShapeTitle/>
        <div className={css.imageWrapper}
             style={cssStyles}
        >
          <MyImage draggable={false} src={imageSrc} imageId={exId} className={css.image}/>
        </div>
      </HTMLContainer>
    </ShapeComponentStoreContext.Provider>)
}, {forwardRef: true})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/image/ImageShapeComponent.tsx